
module.exports = {
  validator: require('./source/loincMappingValidator')
};

